import {connect} from "react-redux";
import {
    CButton,
    CCol,
    CFormInput, CFormSelect,
    CImage,
    CInputGroup,
    CInputGroupText, CModal, CModalBody,
    CModalHeader,
    CModalTitle,
    CRow
} from "@coreui/react";
import React, {useCallback, useEffect, useRef, useState} from "react";
import ProductBarcode from "./ProductBarcode";
import axios from "axios";

const ProductDetail = (props) => {
    const {data, openType} = props;
    const fileRef = useRef();
    const [modal, setModal] = useState({visible: false});
    const [formData, setFormData] = useState({});
    const [imagePath, setImagePath] = useState("../images/noimage.jpg");

    useEffect(() => {
        setFormData(data);
        setImagePath(data.imgPath === null ? "../images/noimage.jpg" : data.imgPath);
    }, [data]);

    const changeImageBtnClick = () => {
        if (data.productCd === '') {
            return;
        }
        fileRef.current.click();
    }

    const onImageUpload = (e) => {
        props.onImageUpload(e);
    };

    return (
        <>
            <CRow>
                <CCol xs={9}>
                    <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: '#87CEFA'}}>
                        <strong>상품 기본 정보</strong>
                    </div>
                    <CRow xs={9}>
                        <CCol>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>상품코드</CInputGroupText>
                                <CFormInput id="restProductCd" value={data.barcode}
                                            maxLength={10}
                                            onChange={(e) => {
                                                props.handler((state) => ({
                                                    ...state,
                                                    barcode: e.target.value
                                                }))
                                            }}
                                            disabled={(openType === "R" || openType === "E")}/>
                            </CInputGroup>
                        </CCol>
                    </CRow>
                    <CRow xs={9}>
                        <CCol>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>상품명</CInputGroupText>
                                <CFormInput id="productNm" value={data.productNm}
                                            onChange={(e) => {
                                                props.handler((state) => ({
                                                    ...state,
                                                    productNm: e.target.value
                                                }))
                                            }}
                                            disabled={openType === "R"}/>
                            </CInputGroup>
                        </CCol>
                    </CRow>
                    <CRow xs={9}>
                        <CCol>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>상품구분</CInputGroupText>
                                <CFormSelect id="productDiv" value={data.productDiv}
                                             onChange={(e) => {
                                                 props.handler((state) => ({
                                                     ...state,
                                                     productDiv: e.target.value
                                                 }))
                                             }}
                                >
                                    <option value={"1"}>일반상품</option>
                                </CFormSelect>
                            </CInputGroup>
                        </CCol>
                        <CCol>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>바코드</CInputGroupText>
                                {/*<CFormInput id="sourceCd" value={data.sourceCd ? data.sourceCd : ""} />*/}
                                <CFormInput id="sourceCd" value={data.sourceCd}
                                            maxLength={20}
                                            onChange={(e) => {
                                                props.handler((state) => ({
                                                    ...state,
                                                    sourceCd: e.target.value
                                                }))
                                            }}
                                            disabled={(openType === "R" || openType === "E")}/>
                                <CButton id="barcode" onClick={() => {
                                    setModal({visible: true});
                                }}>바코드관리</CButton>
                            </CInputGroup>
                        </CCol>
                    </CRow>
                    <CRow xs={9}>
                        <CCol>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>판매단가</CInputGroupText>
                                <CFormInput id="price" value={data.price} disabled={openType === "R"}
                                            onChange={(e) => {
                                                props.handler((state) => ({
                                                    ...state,
                                                    price: e.target.value
                                                }))
                                            }}
                                />
                            </CInputGroup>
                        </CCol>
                        <CCol>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>원가단가</CInputGroupText>
                                <CFormInput id="subPrice" value={data.subPrice} disabled={openType === "R"}
                                            onChange={(e) => {
                                                props.handler((state) => ({
                                                    ...state,
                                                    subPrice: e.target.value
                                                }))
                                            }}
                                />
                            </CInputGroup>
                        </CCol>
                    </CRow>
                    <CRow xs={9}>
                        <CCol>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>수수료사용여부</CInputGroupText>
                                <CFormSelect id="productDiv" value={data.extendYn}
                                             onChange={(e) => {
                                                 props.handler((state) => ({
                                                     ...state,
                                                     extendYn: e.target.value
                                                 }))
                                             }}
                                >
                                    <option value={"N"}>미사용</option>
                                    <option value={"Y"}>사용</option>
                                </CFormSelect>
                            </CInputGroup>
                        </CCol>
                    </CRow>
                    <CRow xs={9}>
                        <CCol>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>봉투사용여부</CInputGroupText>
                                <CFormSelect id="bagYn" value={data.bagYn} disabled={openType === "R"}
                                             onChange={(e) => {
                                                 props.handler((state) => ({
                                                     ...state,
                                                     bagYn: e.target.value
                                                 }))
                                             }}
                                >
                                    <option value={"N"}>미사용</option>
                                    <option value={"Y"}>사용</option>
                                </CFormSelect>
                            </CInputGroup>
                        </CCol>
                        <CCol>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>봉투금액</CInputGroupText>
                                <CFormInput id="bagPrice" value={data.bagPrice} disabled={openType === "R"}
                                            onChange={(e) => {
                                                props.handler((state) => ({
                                                    ...state,
                                                    bagPrice: e.target.value
                                                }))
                                            }}
                                />
                            </CInputGroup>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol xs={6}>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>사용여부</CInputGroupText>
                                <CFormSelect id="useYn" value={data.useYn} disabled={openType === "R"}
                                             onChange={(e) => {
                                                 props.handler((state) => ({
                                                     ...state,
                                                     useYn: e.target.value
                                                 }))
                                             }}
                                >
                                    <option value={"Y"}>Yes</option>
                                    <option value={"N"}>No</option>
                                </CFormSelect>
                            </CInputGroup>
                        </CCol>
                        <CCol xs={6}>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>등록시간</CInputGroupText>
                                <CFormInput id="updTime" value={data.updTime} disabled={true} />

                            </CInputGroup>
                        </CCol>
                    </CRow>

                    <CRow>
                        <CCol xs={12}>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>상품 설명</CInputGroupText>
                                <CFormInput id="67etc1" value={data.etc1} disabled={openType === "R"}
                                            onChange={(e) => {
                                                props.handler((state) => ({
                                                    ...state,
                                                    etc1: e.target.value
                                                }))
                                            }}
                                />
                            </CInputGroup>

                        </CCol>
                    </CRow>
                    {/*<CRow xs={9}>*/}
                    {/*    <CCol>*/}
                    {/*        <CInputGroup className={"mb-1"}>*/}
                    {/*            <CInputGroupText style={{width: 120}}>주문상품구분</CInputGroupText>*/}
                    {/*            <CFormInput id="price" disabled={openType === "R"}/>*/}
                    {/*        </CInputGroup>*/}
                    {/*    </CCol>*/}
                    {/*    <CCol>*/}
                    {/*        <CInputGroup className={"mb-1"}>*/}
                    {/*            <CInputGroupText style={{width: 120}}>주문단위</CInputGroupText>*/}
                    {/*            <CFormInput id="orderUnit" value={data.orderUnit} disabled={openType === "R"}/>*/}
                    {/*        </CInputGroup>*/}
                    {/*    </CCol>*/}
                    {/*</CRow>*/}
                    {/*<CRow xs={9}>*/}
                    {/*    <CCol>*/}
                    {/*        <CInputGroup className={"mb-1"}>*/}
                    {/*            <CInputGroupText style={{width: 120}}>입수/용량</CInputGroupText>*/}
                    {/*            <CFormInput id="orderUnitQty" disabled={openType === "R"}/>*/}
                    {/*        </CInputGroup>*/}
                    {/*    </CCol>*/}
                    {/*    <CCol>*/}

                    {/*    </CCol>*/}
                    {/*</CRow>*/}
                    {/*<CRow xs={9}>*/}
                    {/*    <CCol>*/}
                    {/*        <CInputGroup className={"mb-1"}>*/}
                    {/*            <CInputGroupText style={{width: 120}}>재고단위</CInputGroupText>*/}
                    {/*            <CFormInput id="stockUnit" value={data.stockUnit} disabled={openType === "R"}/>*/}
                    {/*        </CInputGroup>*/}
                    {/*    </CCol>*/}
                    {/*    <CCol>*/}
                    {/*        <CInputGroup className={"mb-1"}>*/}
                    {/*            <CInputGroupText style={{width: 120}}>상품규격</CInputGroupText>*/}
                    {/*            <CFormInput id="stockUnit" value={data.stockUnit} disabled={openType === "R"}/>*/}
                    {/*        </CInputGroup>*/}
                    {/*    </CCol>*/}
                    {/*</CRow>*/}
                    {/*<CRow xs={9}>*/}
                    {/*    <CCol>*/}
                    {/*        <CInputGroup className={"mb-1"}>*/}
                    {/*            <CInputGroupText style={{width: 120}}>제조업체</CInputGroupText>*/}
                    {/*            <CFormInput id="stockUnit" value={data.stockUnit} disabled={openType === "R"}/>*/}
                    {/*        </CInputGroup>*/}
                    {/*    </CCol>*/}
                    {/*    <CCol>*/}
                    {/*        <CInputGroup className={"mb-1"}>*/}
                    {/*            <CInputGroupText style={{width: 120}}/>*/}
                    {/*            <CFormInput id="stockUnit" disabled={openType === "R"}/>*/}
                    {/*        </CInputGroup>*/}
                    {/*    </CCol>*/}
                    {/*</CRow>*/}
                </CCol>
                <CCol xs={3}>
                    <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: '#87CEFA'}}>
                        <strong>상품 이미지</strong>
                    </div>
                    <div className={"clearfix"}>
                        <CImage align={"center"} src={imagePath} width={170} height={170}/>
                    </div>
                    <div className={"d-grid mt-2"}>
                        <CButton size={"sm"} onClick={changeImageBtnClick}>이미지등록/변경</CButton>
                        <input type={"file"} accept={"image/*"} ref={fileRef} style={{display: "none"}}
                               onChange={onImageUpload}/>
                    </div>
                </CCol>
            </CRow>
            <div style={{height: 10}}/>
            <CRow>
                <CCol>
                    <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: '#87CEFA'}}>
                        <strong>상품 부가정보</strong>
                    </div>
                    <CRow>
                        <CCol xs={4}>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>과세여부</CInputGroupText>
                                <CFormSelect id="taxYn" value={data.taxYn} disabled={openType === "R"}
                                             onChange={(e) => {
                                                 props.handler((state) => ({
                                                     ...state,
                                                     taxYn: e.target.value
                                                 }))
                                             }}>
                                    <option value={"Y"}>Yes</option>
                                    <option value={"N"}>No</option>
                                </CFormSelect>
                            </CInputGroup>
                        </CCol>
                        <CCol xs={4}>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>재고관리여부</CInputGroupText>
                                <CFormSelect id="stockYn" value={data.stockYn} disabled={openType === "R"}
                                             onChange={(e) => {
                                                 props.handler((state) => ({
                                                     ...state,
                                                     stockYn: e.target.value
                                                 }))
                                             }}
                                >
                                    <option value={"Y"}>Yes</option>
                                    <option value={"N"}>No</option>
                                </CFormSelect>
                            </CInputGroup>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol xs={4}>
                            <CInputGroup className={"mb-1"} size={"sm"}>
                                <CInputGroupText style={{width: 120}}>제조상품 숨김 여부</CInputGroupText>
                                <CFormSelect id="soldoutYn" value={data.soldoutYn}
                                             disabled={openType === "R"}
                                             onChange={(e) => {
                                                 props.handler((state) => ({
                                                     ...state,
                                                     soldoutYn: e.target.value
                                                 }))
                                             }}
                                >
                                    <option value={"N"}>No</option>
                                    <option value={"Y"}>Yes</option>
                                </CFormSelect>
                            </CInputGroup>
                        </CCol>
                    </CRow>
                    {/*<CRow>*/}
                    {/*    <CCol>*/}
                    {/*        <CInputGroup className={"mb-1"}>*/}
                    {/*            <CInputGroupText style={{width: 120}}>판매가격통제</CInputGroupText>*/}
                    {/*            <CFormInput id="dcYn" value={"휴게소"} disabled={openType === "R"}/>*/}
                    {/*        </CInputGroup>*/}
                    {/*    </CCol>*/}
                    {/*</CRow>*/}
                </CCol>
            </CRow>

            <CModal size={"lg"} backdrop={"static"} alignment={"center"} visible={modal.visible}
                    onClose={() => setModal({visible: false})}>
                <CModalHeader>
                    <CModalTitle>상품 바코드 관리</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <ProductBarcode data={data}/>
                </CModalBody>
            </CModal>
        </>
    );
};

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ProductDetail);
